export interface ConsignmentDetails {
  title: string;
  senderName: string;
  senderOrganization: string;
  receiverName: string;
  receiverOrganization: string;
  weight: string;
  volume: string;
  remainsWithSender: number;
  cancelledBySender: number;
  receivedFromSender: number;
  transferOut: number;
  transferIn: string | number;
  stockOnHand: number;
  reportedLost: number;
  releasedToReceiver: number;
  totalPerSrf: number;
}

export interface Consignment {
  id: string;
  shipment: string;
  vehicle: string;
  arrivingTo: string;
  consignmentNumber: string;
  dispatched: string;
  waybill: string;
  sender: string;
  volume?: number;
  details?: ConsignmentDetails;
}

export interface Section {
  id: string;
  title: string;
  tables: TableData[];
}

export interface TableData {
  id: string;
  title: string;
  data: Consignment[];
}

export const mockConsignments: Consignment[] = [
  {
    id: '1',
    shipment: 'Convoy #22',
    vehicle: '#1',
    arrivingTo: 'Brindisi - UNLB (Customer Address)',
    consignmentNumber: 'BDS-1742',
    dispatched: '01/Sep/25',
    waybill: 'WB-006257',
    sender: 'UNDP',
    volume: 12,
    details: {
      title: 'Food Security – Wheat Flour',
      senderName: 'Gabriel Batistuta',
      senderOrganization: 'United Nations Development Programme',
      receiverName: 'Diego Armando Maradona',
      receiverOrganization: 'United Nations Development Programme',
      weight: '25 Kg',
      volume: '12 m³',
      remainsWithSender: 0,
      cancelledBySender: 0,
      receivedFromSender: 150.0,
      transferOut: 148.0,
      transferIn: '–',
      stockOnHand: 2.0,
      reportedLost: 0,
      releasedToReceiver: 0,
      totalPerSrf: 150.0
    }
  },
  {
    id: '2',
    shipment: 'Convoy #22',
    vehicle: '#1',
    arrivingTo: 'Brindisi - UNLB (Customer Address)',
    consignmentNumber: 'BDS-1743',
    dispatched: '01/Sep/25',
    waybill: 'WB-006257',
    sender: 'UNDP',
    volume: 37
  },
  {
    id: '3',
    shipment: 'Convoy #22',
    vehicle: '#2',
    arrivingTo: 'Brindisi - UNLB (Customer Address)',
    consignmentNumber: 'BDS-1744',
    dispatched: '01/Sep/25',
    waybill: 'WB-006257',
    sender: 'UNDP',
    volume: 37
  },
  {
    id: '4',
    shipment: 'Convoy #25',
    vehicle: '#1',
    arrivingTo: 'Brindisi - UNLB (Customer Address)',
    consignmentNumber: 'BDS-1745',
    dispatched: '01/Sep/25',
    waybill: 'WB-006257',
    sender: 'UNDP',
    volume: 37
  },
  {
    id: '5',
    shipment: 'Convoy #26',
    vehicle: '#1',
    arrivingTo: 'Brindisi - UNLB (Customer Address)',
    consignmentNumber: 'BDS-1746',
    dispatched: '01/Sep/25',
    waybill: 'WB-006257',
    sender: 'UNDP',
    volume: 37
  }
];

export const mockConvoys: Consignment[] = [
  {
    id: '6',
    shipment: 'Convoy #25',
    vehicle: '#1',
    arrivingTo: 'Brindisi - UNLB (Customer Address)',
    consignmentNumber: 'BDS-1745',
    dispatched: '01/Sep/25',
    waybill: 'WB-006257',
    sender: 'UNDP',
    volume: 37
  }
];

export const mockSections: Section[] = [
  {
    id: 'internal-transfers',
    title: 'sections.internalTransfers',
    tables: [
      {
        id: 'customer-address',
        title: 'sections.customerAddress',
        data: mockConsignments
      },
      {
        id: 'convoys-1',
        title: 'sections.convoys',
        data: mockConvoys
      }
    ]
  },
  {
    id: 'customer-deliveries',
    title: 'sections.customerDeliveries',
    tables: [
      {
        id: 'convoys-2',
        title: 'sections.convoys',
        data: mockConvoys
      }
    ]
  }
];

// API mock functions
export const fetchConsignments = async (): Promise<Consignment[]> => {
  // Simulate API delay
  await new Promise((resolve) => setTimeout(resolve, 500));
  return mockConsignments;
};

export const fetchSections = async (): Promise<Section[]> => {
  // Simulate API delay
  await new Promise((resolve) => setTimeout(resolve, 500));
  return mockSections;
};
